/** biome-ignore-all lint/a11y/useValidAnchor: Placeholder links */

import FormContainer, { CheckboxField, SubmitButton } from "components/form";
import { ButtonLevel } from "components/ui/Button";
import { LinkButton } from "components/ui/Link";
import Layout from "./Layout";

const Terms = ({ onCancel, embedded, goToNextStep }) => {
  const onSubmit = () => {
    goToNextStep();
  };

  return (
    <FormContainer onSubmit={onSubmit}>
      <Layout
        heading="Please accept the following terms to continue."
        actions={
          <>
            {embedded && <LinkButton onClick={onCancel}>Cancel</LinkButton>}

            <SubmitButton level={ButtonLevel.cta} fullWidth>
              Continue
            </SubmitButton>
          </>
        }
      >
        <CheckboxField
          name="card_agreement"
          label={
            <>
              I have read and accept the <a href="#">Card Agreement</a>
            </>
          }
          required
        />
        <CheckboxField
          name="ewa_terms"
          label={
            <>
              I have read and accept the <a href="#">EWA Terms of Service</a>
            </>
          }
          required
        />
      </Layout>
    </FormContainer>
  );
};

export default Terms;
